// GA4 conversion event helpers
// Measurement ID: G-WF8X083Z4S
// Property ID: 526411176
//
// IMPORTANT: After deploying, mark these as Key Events in GA4:
//   GA4 > Admin > Events > mark as key event:
//   - book_click
//   - booking_submit
//   - phone_click
//   - pricing_view
//   - portfolio_view

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

const isGtagAvailable = (): boolean =>
  typeof window !== "undefined" && typeof window.gtag === "function";

/** Fired when user clicks any Book / Schedule CTA */
export const trackBookClick = (source?: string) => {
  if (!isGtagAvailable()) return;
  window.gtag("event", "book_click", {
    event_category: "conversion",
    event_label: source ?? "unknown",
  });
};

/** Fired when the booking form embed sends a success postMessage */
export const trackBookingSubmit = () => {
  if (!isGtagAvailable()) return;
  window.gtag("event", "booking_submit", {
    event_category: "conversion",
    event_label: "order_form",
  });
};

/** Fired when user clicks a tel: link. Pass location context (e.g. 'footer', 'hero', 'contact_page') */
export const trackPhoneClick = (location?: string) => {
  if (!isGtagAvailable()) return;
  window.gtag("event", "phone_click", {
    event_category: "conversion",
    location: location ?? "unknown",
  });
};

/** Fired when /pricing route mounts */
export const trackPricingView = () => {
  if (!isGtagAvailable()) return;
  window.gtag("event", "pricing_view", {
    event_category: "engagement",
  });
};

/** Fired when /portfolio route mounts */
export const trackPortfolioView = () => {
  if (!isGtagAvailable()) return;
  window.gtag("event", "portfolio_view", {
    event_category: "engagement",
  });
};
